import Vue from 'vue'
import VueResource from 'vue-resource'
import Router from './../router/index'
Vue.use(VueResource)

// Vue.http.options.root = 'https://staging.laosseguridad.com.co/api/v1/';
// Vue.http.options.root = 'https://4eb7-204-199-118-233.ngrok.io/api/v1/';
// Vue.http.options.root = 'http://www.laosseguridad.com.co/api/v1/';
Vue.http.options.root = 'https://laosseguridad.com.co/api/v1/';
// Vue.http.options.root = 'http://192.168.18.80:3000/api/v1/';
Vue.http.headers.common['Access-Control-Allow-Origin'] = true;
Vue.http.headers.common['Access-Control-Allow-Origin'] = '*';
Vue.http.headers.common['Accept-Language'] = 'es';
Vue.http.headers.common["DYNAMIC-LANGUAGE"] = 'es';
Vue.http.headers.common["Content-Type"] = "application/json";
Vue.http.headers.common.Accept = "application/json";
Vue.http.headers.common['Access-Control-Allow-Methods'] = 'GET, POST, PATCH, PUT, DELETE, OPTIONS';
Vue.http.headers.common['Access-Control-Allow-Headers'] = 'Origin, Content-Type, Authentication, Accept-Language';
Vue.http.headers['Access-Control-Max-Age'] = '1728000';
Vue.http.interceptors.push((request, next) => {
    if (request.url != "administrators/users/sign_in") {
        console.log(request);
    }
    if (request.url != "company/new" && request.url != "company/new_alerts") {
        Router.app.updateLoader(true)
    }

    next(response => {
        Router.app.updateLoader(false)
        console.log(response);
        if (response.headers.map.tag == "expired") {
            localStorage.setItem('crypto', response.headers.map.meta);

        } else if (response.status == 401 || response.status == 412) {
            localStorage.setItem('user', '');
            localStorage.setItem('crypto', '');
            localStorage.setItem('isAdmin', '');
            localStorage.setItem('noAuth', true);
            console.log('ERROR EN LA SESIÓN DEL USUARIO')
            console.log(response)
            localStorage.setItem('message', 'Ha ocurrido un error y se ha cerrado sesión');
            Router.push("/");
        } else {
            response.json = () => { return { messages: response.body } }
        }
    });
});


// WEBPACK FOOTER //
// ./src/vue/resource/index.js